module.exports = __webpack_public_path__ + "img/home-content.beb2983d.jpg";